import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WifiOff } from "lucide-react";
import { useLiveMarket } from "@/context/LiveMarketContext";

const HOLD_MS = 10000; // a feed must stay down this long before the banner appears (no flash on a quick reconnect)

// Site-wide notice shown ONLY when a real-time feed (or the whole stream) is down — never because an individual
// asset is QUIET/STALE between trades. Disappears on its own when the feed recovers.
export const FeedOutageBanner = () => {
  const ctx = useLiveMarket();
  const [since, setSince] = useState(null);
  const [, force] = useState(0);
  const feed = ctx?.feed;
  const names = Object.keys(feed?.sources || {});
  const down = names.filter((n) => !feed.sources[n].live);
  const seen = !!feed?.lastMsgAt;                       // never alarm before the first status has arrived
  const streamDown = seen && !feed.connected;
  const outage = seen && (streamDown || (down.length > 0 && names.length > 0));

  useEffect(() => { setSince((s) => (outage ? s ?? Date.now() : null)); }, [outage]);
  useEffect(() => { if (!since) return undefined; const t = setTimeout(() => force((x) => x + 1), HOLD_MS + 50); return () => clearTimeout(t); }, [since]);
  if (!since || Date.now() - since < HOLD_MS) return null;

  const all = streamDown || down.length === names.length;
  const which = down.map((n) => `feed ${names.indexOf(n) + 1}`).join(", ");
  return (
    <div data-testid="feed-outage-banner" role="status" className="w-full flex items-center justify-center gap-2 px-4 py-2 text-[11px] md:text-xs"
         style={{ background: "rgba(245,158,11,0.12)", borderBottom: "1px solid rgba(245,158,11,0.35)", color: "#fcd34d" }}>
      <WifiOff className="w-3.5 h-3.5 shrink-0" />
      <span className="font-medium">{all ? "REAL-TIME MARKET FEED DOWN" : `REAL-TIME ${which.toUpperCase()} DOWN`}</span>
      <span className="opacity-90">
        — {all ? "live prices may be stale: the last price received is shown, not a current quote. CoinGecko polled prices keep refreshing."
               : `prices from that feed may be stale (last price shown, not current). Other feeds and the CoinGecko fallback keep updating.`}
      </span>
      <Link to="/feed-health" className="underline underline-offset-2 hover:text-amber-200 shrink-0" data-testid="feed-outage-banner-link">Feed health</Link>
    </div>
  );
};
